import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "status-warning",
  "use": "status-warning-usage",
  "viewBox": "0 0 76.03 76.03",
  "content": "<symbol viewBox=\"0 0 76.03 76.03\" id=\"status-warning\"><title>资源 4</title><g id=\"status-warning_图层_2\" data-name=\"图层 2\"><g id=\"status-warning_图层_1-2\" data-name=\"图层 1\"><path d=\"M76,38A38,38,0,1,0,38,76,38,38,0,0,0,76,38ZM40.61,42.08a2.55,2.55,0,1,1-5.1,0V22.81a2.55,2.55,0,0,1,5.1,0Zm.62,10.17a3,3,0,0,1-3.19,3,3,3,0,1,1,0-6.07A3,3,0,0,1,41.23,52.25Z\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/status-warning.svg
// module id = KvwK
// module chunks = 264